/**
 * localStorage with expire wrapper
 */

const localStorage = window.localStorage;

/**
 * Method unsets value in localStorage
 */
export function unset(key) {
  localStorage.removeItem(key);
}

/**
 * Method gets value from localStorage
 * @param key
 */
export function get(key) {
  if (!localStorage[key]) {
    return null;
  }

  var object = JSON.parse(localStorage[key]);

  if (object.timestamp === null || new Date().getTime() < object.timestamp) {
    return object.value;
  }

  return null;
}

/**
 * Method sets value in local storage
 *
 * @param {String} key
 * @param {*} value
 * @param {Number=} expire in seconds
 */
export function set(key, value, expire) {
  var object;

  if (!expire) {
    object = {
      value: value,
      timestamp: null
    };
  } else {
    object = {
      value: value,
      timestamp: new Date().getTime() + expire * 1000
    };
  }

  localStorage[key] = JSON.stringify(object);
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/local-storage.js
 **/